import { Emitter } from '@epihub/core/src/events';
import type { Message } from '@krishanmadan/core/src/types';

export const messageStreamEvent = Emitter.event<{
  visitorId: string;
  message: Message;
}>('messageStreamEvent')((data) => ({
  visitorId: data.visitorId,
}));
